// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p2-1";
export var messageSideRight = "_p2-2";
export var orderLookupBubbleContainer = "_p2-0";
export var submitButton = "_p2-3";